// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `span, a {
  color: #002060 !important;
}

.page {
  background-color: rgba(255, 255, 255, 0.9);
  padding: 50px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
}

.container {
  padding-top: 160px;
  padding-left: 10vw;
  padding-right: 10vw;
  padding-bottom: 100px;
}

.container-fluid {
  background-size: cover;
}

.headingContainer {
  display: block;
}

.description {
  width: 100%;
}

h2 {
  color: #002060;
  margin-bottom: 10px;
}

.userFunction {
  margin-bottom: 10px;
}

img {
  width: 285px;
  margin-bottom: 40px;
  float: right;
  margin-left: 50px;
}

@media screen and (max-width: 1000px) {
  img {
    width: 100%;
  }
}
.details {
  display: flex;
  flex-direction: column;
  padding-top: 20px;
}
.details .detail {
  display: flex;
  margin-bottom: 10px;
  flex-wrap: nowrap;
}
.details .detail i {
  padding-right: 15px;
}

.thesisCover {
  padding: 15px;
}
.thesisCover img {
  width: 100%;
}

@media screen and (max-width: 575px) {
  .container {
    padding: 0;
    padding-top: 100px;
    padding-bottom: 100px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/user/user.component.scss"],"names":[],"mappings":"AACA;EACE,yBAAA;AAAF;;AAGA;EACE,0CAAA;EACA,aAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;AAAF;;AAKA;EACE,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;AAFF;;AAKA;EACE,sBAAA;AAFF;;AAKA;EACE,cAAA;AAFF;;AAKA;EACE,WAAA;AAFF;;AAKA;EACE,cAAA;EACA,mBAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,YAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;AAFF;;AAKA;EACE;IACE,WAAA;EAFF;AACF;AAKA;EACE,aAAA;EACA,sBAAA;EACA,iBAAA;AAHF;AAKE;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;AAHJ;AAKI;EACE,mBAAA;AAHN;;AAUA;EACE,aAAA;AAPF;AASE;EACE,WAAA;AAPJ;;AAWA;EACE;IACE,UAAA;IACA,kBAAA;IACA,qBAAA;EARF;AACF","sourcesContent":["//@import url('https://fonts.googleapis.com/css?family=PT+Sans');\r\nspan, a {\r\n  color: #002060 !important;\r\n}\r\n\r\n.page {\r\n  background-color: rgba(255, 255, 255, 0.9);\r\n  padding: 50px;\r\n  width: 100%;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n\r\n\r\n}\r\n\r\n.container {\r\n  padding-top: 160px;\r\n  padding-left: 10vw;\r\n  padding-right: 10vw;\r\n  padding-bottom: 100px;\r\n}\r\n\r\n.container-fluid{\r\n  background-size: cover;\r\n}\r\n\r\n.headingContainer {\r\n  display: block;\r\n}\r\n\r\n.description {\r\n  width: 100%;\r\n}\r\n\r\nh2 {\r\n  color: #002060;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.userFunction {\r\n  margin-bottom: 10px;\r\n}\r\n\r\nimg {\r\n  width: 285px;\r\n  margin-bottom: 40px;\r\n  float: right;\r\n  margin-left: 50px;\r\n}\r\n\r\n@media screen and (max-width:1000px) {\r\n  img {\r\n    width: 100%\r\n  }\r\n}\r\n\r\n.details {\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding-top: 20px;\r\n\r\n  .detail {\r\n    display: flex;\r\n    margin-bottom: 10px;\r\n    flex-wrap: nowrap;\r\n\r\n    i {\r\n      padding-right: 15px;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n\r\n.thesisCover {\r\n  padding: 15px;\r\n\r\n  img {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n@media screen and (max-width:575px) {\r\n  .container {\r\n    padding: 0;\r\n    padding-top: 100px;\r\n    padding-bottom: 100px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
